import React, { Fragment } from "react";
import DataGrid from "../../../dataGrid";
import GridConfig from "./ibplanningSummaryGridConfig";
import { withStyles } from "@material-ui/core";
import styles from "../../Settings/styles";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import SaveAltSharp from "@material-ui/icons/SaveAltSharp";
import Tooltip from "../../../common/StyledToolTip";
import { formatDate } from "../../../dataGrid/gridUtilities";
import Clear from "@material-ui/icons/CancelOutlined";
import { csvFormulaInjectionSanitizer } from "../../../../utilities/csvUtils";

class IBPlanningSummaryGrid extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new GridConfig();
    this.gridApi = null;
    this.state = {
      quickFilterText: ""
    };
  }
  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  updateQuickFilterText = event => {
    this.setState({
      quickFilterText: event.target.value
    });
  };

  exportCSV = () => {
    if (!this.props.data.length || !this.gridApi) {
      return;
    }
    const columnIds = this.gridApi.columnController
      .getAllGridColumns()
      .reduce((columnKeys, column) => {
        if (column.colDef.headerName) {
          columnKeys.push(column.colId);
        }
        return columnKeys;
      }, []);

    const planDate = this.props.data.find(
      terminals => terminals.planDate !== null
    ).planDate;
    const params = {
      fileName: `IBPlanning_Operations_Report_${formatDate({
        value: planDate
      })}`,
      columnKeys: columnIds,
      processCellCallback: (cell) => csvFormulaInjectionSanitizer(cell.value)
    };
    this.gridApi.exportDataAsCsv(params);
  };

  render() {
    const { config } = this.gridConfig;
    const { classes } = this.props;
    return (
      <Fragment>
        <header
          className={`${classes.moduleHeader} ${classes.reportsIBPlanningGridHeader}`}
        >
          <span>IB Planning Summary</span>
          <div className={classes.gridActionIcons}>
            <span className={classes.searchContainer}>
              <div className={classes.searchIcon}>
                <SearchIcon />
              </div>
              <InputBase
                placeholder="Search…"
                classes={{
                  root: classes.searchInputRoot,
                  input: classes.searchInput
                }}
                onChange={this.updateQuickFilterText}
                value={this.state.quickFilterText}
                endAdornment={
                  <Clear
                    classes={{
                      root: `${classes.clearIcon} ${
                        this.state.quickFilterText
                          ? classes.iconVisible
                          : classes.iconHidden
                      }`
                    }}
                    onClick={() =>
                      this.updateQuickFilterText({ target: { value: "" } })
                    }
                    display={this.state.quickFilterText ? "none" : "block"}
                  />
                }
              />
            </span>
            <span onClick={this.exportCSV} className={classes.headerIconStyles}>
              <Tooltip title="Export Data">
                <SaveAltSharp />
              </Tooltip>
            </span>
          </div>
        </header>
        <div className={classes.reportsIBPlanningGridContainer}>
          <div className={`${classes.dataGrid} ${classes.anchorPointContent}`}>
            <DataGrid
              defaultColDef={config.defaultColDef}
              columnDefs={config.columns}
              config={config}
              rowData={this.props.data}
              enableSorting={config.enableSorting}
              onGridReady={this.onGridReady}
              quickFilterText={this.state.quickFilterText}
            />
          </div>
        </div>
      </Fragment>
    );
  }
}
export default withStyles(styles)(IBPlanningSummaryGrid);
